import { computed, signal, Signal } from '@angular/core';
import { Filter } from '../filter/types/filter';
import { filter } from '../filter/functions/filter.function';
import { Explorer, ExplorerAddonFactory } from './explorer';

export interface FilterExplorer<T> extends Explorer<T>{
  filterParams: Signal<Filter[]>;
  count: Signal<number>;
  filter(options: Filter[]): void;
}

export interface FilterExplorerOptions {
  defaultFilters?: Filter[];
}

export function withFilter<T>(options?: FilterExplorerOptions): ExplorerAddonFactory<T, FilterExplorer<T>> {
  return <T>(source: Signal<T[]>): FilterExplorer<T> => filterList(source, options);
}

function filterList<T>(source: Signal<T[]>, options?: FilterExplorerOptions): FilterExplorer<T>{
  const filterParams = signal<Filter[]>(options?.defaultFilters ?? []);
  const result = computed(() => {
    const items = source() ?? [];
    const params = filterParams();
    if(params.length === 0)
      return items;
    return filter(items, params);
  });
  const count = computed(() => result().length);
  return {
    filterParams,
    source,
    result,
    count,
    filter: (o) => filterParams.set(o),
  }
}
